import { create } from 'zustand';
import type { AdminLoginResponse, AuthUser } from '@koyomi/shared';

interface AdminAuthState {
  status: 'booting' | 'anonymous' | 'authenticated';
  accessToken: string | null;
  user: AuthUser | null;
  setSession: (s: AdminLoginResponse) => void;
  setAnonymous: () => void;
  clear: () => void;
}

/** Sessão do Admin: token exclusivo (amr pwd+totp) em memória; refresh em cookie próprio. */
export const useAdminAuth = create<AdminAuthState>((set) => ({
  status: 'booting',
  accessToken: null,
  user: null,
  setSession: (s) => set({ status: 'authenticated', accessToken: s.accessToken, user: s.user }),
  setAnonymous: () => set({ status: 'anonymous', accessToken: null, user: null }),
  clear: () => set({ status: 'anonymous', accessToken: null, user: null }),
}));
